import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import slugify from 'react-slugify';
import { MenuContext, MobileContext } from '../../../context/DataContext';
import { reportData } from '../../../data/report-data/report-data/reportData';
import NoMatch from '../../no-match/NoMatch';
import Header from '../../../components/layout/header/Header';
import DynamicWordPressHeader from '../../../components/layout/header/DynamicWordPressHeader';
import MainSidebar from '../../../components/layout/sidebar/main-sidebar/MainSidebar';
import ReportsSidebar from '../../../components/layout/sidebar/reports-sidebar/ReportsSidebar';
import WordPressSidebar from '../../../components/layout/sidebar/wordpress-sidebar/WordPressSidebar';
import DynamicReportContentAutoSlug from '../../../components/reports/DynamicReportContentAutoSlug';
import IPv6EnEquiposCPE from '../reports/equipos-cpe-version-1-2020/IPv6EnEquiposCPE';
import OperadoresDespliegueIPv6 from '../report-preview/OperadoresDespliegueIPv6';
import EstadisticasTendencias2020 from '../report-preview/EstadisticasTendencias2020';
import Footer from '../../../components/layout/footer/Footer';
import V2EquiposCPE from '../report-preview/V2EquiposCPE';
import EquiposCPEVersion2020 from '../report-preview/EquiposCPEVersion2020'; 
import GenericWordPressReport from '../../interconnection/reports/evolucion-global-y-regional-de-la-adopcion-de-rpki/GenericWordPressReport';
import UseLang from '../../../hooks/UseLang';
import RFC8950Preview from '../report-preview/RFC8950Preview';


// Objeto que mapea los componentes con sus identificadores
const reportComponents = {
    operadoresDespliegueIPv6: OperadoresDespliegueIPv6,
    tendenciasIPv62016: EstadisticasTendencias2020,
    soporteIPv6EnEquiposCPE2020: IPv6EnEquiposCPE,
    soporteIPv6EnEquiposCPE2021: V2EquiposCPE,
    rfc8950: GenericWordPressReport, // Componente genérico de WordPress
    // Agregar más reportes aquí
};

function HomeIPv6({ lang, routes, myRoutes }) {
    const { isMobile } = useContext(MobileContext)
    const { isIndice, openIndice } = useContext(MenuContext)
    
    // Función para detectar si un componente es de WordPress
    const isWordPressComponent = (reportId) => {
        // Lista de componentes que usan WordPress
        const wordpressComponents = ['rfc8950'];
        return wordpressComponents.includes(reportId);
    };
    
    // Función para obtener el slug de WordPress basado en el reportId
    const getWordPressSlug = (reportId) => {
        const slugMap = {
            'rfc8950': 'implementacion-del-rfc8950-para-la-transicion-a-ipv6-only-soporte-de-ipv4aas-en-redes-mikrotik'
        };
        return slugMap[reportId];
    };

    // Generar rutas dinámicamente desde reportData
    const generateRoutes = () => {
        return Object.entries(reportData).map(([reportId, reportContent]) => {
            const Component = reportComponents[reportId];
            if (!Component) return null;

            const isWordPress = isWordPressComponent(reportId);
            const wpSlug = isWordPress ? getWordPressSlug(reportId) : null;
            
            // Para componentes de WordPress, usar el slug de WordPress directamente
            // Para componentes normales, generar slug desde el título
            const sluggedPath = isWordPress ? wpSlug : slugify(reportContent[lang]?.title || reportContent.es.title);

            return (
                <Route
                    key={reportId}
                    path={sluggedPath}
                    element={<>
                        <Header
                            url_es={`/es/${myRoutes?.es?.ipv6}/${slugify(reportContent?.es?.title)}`}
                            url_en={`/en/${myRoutes?.en?.ipv6}/${slugify(reportContent?.en?.title)}`}
                            url_pt={`/pt/${myRoutes?.pt?.ipv6}/${slugify(reportContent?.pt?.title)}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {/* Sidebar lateral */}
                                    {((!isMobile) || (isMobile && isIndice)) && (
                                        <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                            {isWordPress ? (
                                                <WordPressSidebar
                                                    slug={wpSlug}
                                                />
                                            ) : reportContent?.es?.items ? (
                                                <ReportsSidebar
                                                    menu_lateral={`${slugify(reportContent?.es?.title)}`}
                                                    category={'ipv6'}
                                                    routes={routes}
                                                    lang={lang}
                                                />
                                            ) : (
                                                <MainSidebar
                                                    category='ipv6'
                                                    lang={lang}
                                                    routes={routes}
                                                />
                                            )}
                                        </aside>
                                    )}
                                    
                                           {/* Contenido principal */}
                                           <main className="report_content_wrapper">
                                               <section>
                                                   {isWordPress ? (
                                                       <Component
                                                           displayMode="full"
                                                           lang={lang}
                                                           reportId={reportId}
                                                       />
                                                   ) : (
                                                       <Component
                                                           displayMode="full"
                                                           lang={lang}
                                                       />
                                                   )}
                                               </section>
                                           </main>
                                </div>
                            </div>
                        </div>
                        {isMobile &&
                            <div className="report_button_menu" onClick={openIndice}>
                                <div>
                                    {!isIndice && <i className="fas fa-list"></i>}
                                    {isIndice && <i className="fas fa-times"></i>}
                                </div>
                            </div>
                        }
                        <Footer {...footerProps} />
                    </>
                    }
                />
            );
        });
    };

    // Defino props con className para agregar al elemento Footer
    const footerProps = {
        className: `master_foot_reports ${!isMobile ? 'foot_report' : 'basic_foot'}`,
        ...((!isMobile) && { footer: 'reports' })
    };

    const createHome = () => {
        return (
            <Route
                index
                element={
                    <>
                        <Header
                            url_es={`/es/${myRoutes?.es?.ipv6}`}
                            url_en={`/en/${myRoutes?.en?.ipv6}`}
                            url_pt={`/pt/${myRoutes?.pt?.ipv6}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {!isMobile && (
                                        <aside className="lateral_menu_wrapper">
                                            <MainSidebar
                                                category='ipv6'
                                                lang={lang}
                                                routes={routes}
                                            />
                                        </aside>
                                    )}
                                    <main className="report_content_wrapper">
                                        <section>
                                            <div className="report_list">
                                                <UseLang es>Informes técnicos, IPv6 </UseLang>
                                                <UseLang en>Technical Reports, IPv6</UseLang>
                                                <UseLang pt>Relatórios técnicos, IPv6 </UseLang>
                                                <RFC8950Preview/>
                                                <EstadisticasTendencias2020 />
                                                <OperadoresDespliegueIPv6 />
                                                <EquiposCPEVersion2020 />
                                                <V2EquiposCPE />
                                            </div>
                                        </section>
                                    </main>
                                </div>
                            </div>
                        </div>
                        <Footer
                            footer='reports'
                            className="master_foot_reports foot_report"
                        />
                    </>
                }
            />
        );
    };
    return (
        <Routes>
            {/* Ruta absoluta en "/es/ipv6" */}
            {createHome()}
            {/* Rutas para reportes de ipv6 "/es/ipv6/reportContent?.es?.title"  */}
            {generateRoutes()}
            {/* Ruta catch-all para WordPress que acepte cualquier slug */}
            <Route
                path=":anySlug"
                element={<>
                    <DynamicWordPressHeader 
                        myRoutes={myRoutes}
                        category="ipv6"
                    />
                    <div className="report_work_table">
                        <div className="report_main_wrapper">
                            <div>
                                {/* Sidebar lateral */}
                                {((!isMobile) || (isMobile && isIndice)) && (
                                    <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                        <WordPressSidebar
                                            slug={null} // Se detectará automáticamente
                                        />
                                    </aside>
                                )}
                                
                                {/* Contenido principal - usa DynamicReportContentAutoSlug para detectar el slug automáticamente */}
                                <main className="report_content_wrapper">
                                    <section>
                                        <DynamicReportContentAutoSlug />
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                    {isMobile &&
                        <div className="report_button_menu" onClick={openIndice}>
                            <div>
                                {!isIndice && <i className="fas fa-list"></i>}
                                {isIndice && <i className="fas fa-times"></i>}
                            </div>
                        </div>
                    }
                    <Footer {...footerProps} />
                </>
                }
            />
            {/* Rutas que no coinciden Ejemplo: "/es/ipv6/example" */}
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
};

export default HomeIPv6;